import { useContext, useEffect } from 'react';
import type { ChatbotRequestContext } from '@ev-tech/search-modules-api';

import { ChatbotStoreContext } from '../stores/useChatbot';

/** Memoize the context object. Pass null while unavailable. Does nothing without a ChatbotProvider. */
export const useRegisterChatbotContext = (context: ChatbotRequestContext | null) => {
  const store = useContext(ChatbotStoreContext);

  useEffect(() => {
    if (context && store) return store.getState().registerContext(context);
  }, [store, context]);
};
